import { Utils } from "../utils"

export { MainNav }

class MainNav {
    #chapters = []

    constructor() {
        document.querySelectorAll("#mainNav > div  nav:first-child a")
            .forEach(link => {
                this.#chapters.push(link)

                link.style.setProperty("--offset", (Utils.basicRandomValue() + 1) * 50 + "%")
                link.style.setProperty("--border", Array.from(
                    { length: 4 },
                    () => (Utils.basicRandomValue() + 3) + "em").join(" ")
                )

            })
    }

    highlightChapter(id) {
        const current = this.#chapters[id]

        this.#chapters.forEach((link) => { link.classList.remove("current") })

        current?.classList.add("current")
        current?.scrollIntoView({ behavior: "smooth", inline: "center" })
    }
}